/**
 * track — telemetría de comportamiento del cliente (fire-and-forget).
 * Envía un evento a /api/cliente/evento sin bloquear la UI ni romper nada si falla.
 * Tipos válidos definidos en backend/routes/eventos_comportamiento.py.
 */
import axios from 'axios';

const API = '/api';

export function track(tipo, detalle = '', valor = null) {
  try {
    // No await: no debe frenar la experiencia del cliente.
    axios.post(`${API}/cliente/evento`, { tipo, detalle, valor }).catch(() => {});
  } catch (e) { /* noop */ }
}
